export const FETCH_PROFILE = "account/FETCH_PROFILE";
export const FETCH_PROFILE_SUCCESS = 'account/FETCH_PROFILE_SUCCESS'
export const FETCH_STATISTIC_SUCCESS = "account/FETCH_STATISTIC_SUCCESS";
